<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'Impressum'
})
</script>

<template>
  <div id="impressum" class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h1>Impressum</h1>
      <p>
        Angaben gemäß § 5 TMG <br />
        <br />

        Theo Döllmann <br />
        c/o flexdienst – #21259 <br />
        Kurt-Schumacher-Straße 74 <br />
        67663 Kaiserslautern <br />
      </p>
      <p>info@bahnvorhersage.de</p>
      <h2>Haftungsausschluss:</h2>
      <h3>Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
        Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
        mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
        nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
        konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
        Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
      <h3>Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
        deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
        Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
        des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
        privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht
        vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
        werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </p>
      <h3>Nutzungsbedingungen</h3>
      <p>
        Betreiber dieser Seite sind die im Impressum genannten Personen. Durch Nutzung dieser
        Webseite erklären Sie sich mit den Nutzungsbedingungen einverstanden. Dies gilt auch dann,
        wenn Sie die Webseite oder Bereiche davon von anderen Webseiten aus nutzen.
      </p>
      <p>Die Webseite darf ausschließlich zu folgenden Zwecken genutzt werden:</p>
      <ol>
        <li>Anzeigen dieser Webseite</li>
        <li>Nutzung weiterer Funktionen, die auf dieser Webseite verfügbar gemacht werden</li>
      </ol>
      <p>Jede andere Nutzung bedarf der vorherigen schriftlichen Zustimmung der Betreiber.</p>
      <p>
        Die Bearbeitung, Vervielfältigung, Verbreitung und/oder die öffentliche Wiedergabe der
        Webseite und ihrer Inhalte zu gewerblichen Zwecken sind ohne vorherige schriftliche
        Zustimmung untersagt.
        <b
          >Dies gilt gerade auch unter Verwendung automatisierter Systeme oder automatisierter
          Software zur Extraktion von Inhalten.</b
        >
      </p>
      <p>
        Es sind sämtliche Maßnahmen zu unterlassen, die störend in die Funktion der Webseite
        eingreifen können. Dazu gehören auch solche, die eine übermäßige oder unzumutbare Belastung
        der Webseiten-Infrastruktur zur Folge haben können.
      </p>
    </div>
  </div>
</template>
